import { render, staticRenderFns } from "./CaseViewerHeaderTitle.vue?vue&type=template&id=0399fd63&scoped=true&"
import script from "./CaseViewerHeaderTitle.vue?vue&type=script&lang=js&"
export * from "./CaseViewerHeaderTitle.vue?vue&type=script&lang=js&"
import style0 from "./CaseViewerHeaderTitle.vue?vue&type=style&index=0&id=0399fd63&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0399fd63",
  null
  
)

export default component.exports